module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/Index"
    }
  }, [_vm._v("缴费页")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), (_vm.tipText !== '') ? _c('div', {
    staticClass: "notice"
  }, [_c('van-notice-bar', {
    attrs: {
      "left-icon": "volume-o",
      "text": _vm.tipText
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mainVisible),
      expression: "mainVisible"
    }]
  }, [_c('div', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "content-tital"
  }, [_vm._v("公寓用品选择")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "content-group",
    model: {
      value: (_vm.dormConfigCheckList),
      callback: function($$v) {
        _vm.dormConfigCheckList = $$v
      },
      expression: "dormConfigCheckList"
    }
  }, [_vm._l((_vm.dormConfigList), function(item) {
    return [_c('el-checkbox', {
      key: item.modeId,
      staticClass: "content-group-item",
      attrs: {
        "disabled": item.field1 === '01',
        "label": item.modeId
      }
    }, [_c('div', [_c('div', [_vm._v(_vm._s(item.modeName))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#e6a23c",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s('价格：' + _vm.Ginkgo.format(item.modeValue, 'money')))])])]), _vm._v(" "), _c('el-divider', {
      key: item.modeId,
      staticClass: "content-divider"
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-refund"
  }, [_c('div', [_vm._v(_vm._s('退费金额:' + _vm.Ginkgo.format(_vm.refundMoney, 'money')))])]), _vm._v(" "), (false) ? _c('div', [_c('div', {
    staticClass: "content-tital"
  }, [_vm._v("退款银行卡信息")]), _vm._v(" "), (_vm.cardInfo.length === 0) ? _c('el-row', {
    staticStyle: {
      "height": "60px",
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("银行卡信息为空，请先去维护银行卡信息！")])]) : _c('el-form', {
    ref: "form",
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "80px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账户名"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true"
    },
    model: {
      value: (_vm.form.acnm),
      callback: function($$v) {
        _vm.$set(_vm.form, "acnm", $$v)
      },
      expression: "form.acnm"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账户号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true"
    },
    model: {
      value: (_vm.form.acno),
      callback: function($$v) {
        _vm.$set(_vm.form, "acno", $$v)
      },
      expression: "form.acno"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true"
    },
    model: {
      value: (_vm.form.bankNm),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankNm", $$v)
      },
      expression: "form.bankNm"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "100%",
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipVisible),
      expression: "tipVisible"
    }]
  }, [_c('div', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "content-tital"
  }, [_vm._v("公寓用品领用项\n          "), (_vm.isClaim === '00') ? _c('el-tag', {
    staticClass: "style-tag",
    attrs: {
      "type": "success"
    }
  }, [_vm._v("已完成")]) : (_vm.isClaim === '01') ? _c('el-tag', {
    staticClass: "style-tag",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("待确认")]) : _c('el-tag', {
    staticClass: "style-tag",
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("待领取")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "1rem 0 0 0"
    }
  }, [_c('table', {
    staticStyle: {
      "color": "rgb(9, 9, 9)",
      "text-align": "center",
      "border-collapse": "collapse",
      "width": "95%",
      "margin": "auto"
    },
    attrs: {
      "border": "1"
    }
  }, [_c('tr', {
    staticStyle: {
      "line-height": "4vh",
      "font-size": "1rem",
      "font-weight": "500",
      "background": "#409eff"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("收费标准(元)")]), _vm._v(" "), _c('td', [_vm._v("是否领取")])]), _vm._v(" "), _vm._l((_vm.claimApplyList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.supplyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((item.applyStatus === '00') ? '是' : '否'))])])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f8e0bd"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("退款金额")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.refundMoney, 'money')))]), _vm._v(" "), _c('td')])], 2)]), _vm._v(" "), (_vm.isClaim === '01' && _vm.isApplyTime) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "padding": "15px 10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "46%"
    },
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.update()
      }
    }
  }, [_vm._v("重新提交")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "46%"
    },
    attrs: {
      "type": "success",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.toPrint()
      }
    }
  }, [_vm._v("打印领用单")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printVisible),
      expression: "printVisible"
    }],
    ref: "printContent"
  }, [(_vm.claimApplyList.length > 0) ? _c('div', {
    staticClass: "content"
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "padding": "10px",
      "border-radius": "5px",
      "font-size": "3vw"
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "rgb(9, 9, 9)",
      "text-align": "center",
      "font-size": "4.5vw",
      "padding": "0 0 1vh 0"
    }
  }, [_vm._v("西安翻译学院新生入学公寓用品领用单")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "85%"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("姓名：" + _vm._s(_vm.curStudent.studentName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("性别：" + _vm._s(_vm.curStudent.sex))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("学号：" + _vm._s(_vm.curStudent.studentNo))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("领用点：" + _vm._s(_vm.claimApplyList[0].dealName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("公寓：" + _vm._s(_vm.dormRow.flatsName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("宿舍：" + _vm._s(_vm.dormRow.roomNo) + " 号 " + _vm._s(_vm.dormRow.bedNo) + " 床位")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("申请日期：" + _vm._s(_vm.Ginkgo.format(_vm.claimApplyList[0].applyTm, 'time')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("缴费订单号：" + _vm._s(_vm.dormOrderInfo.orderNo))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("缴费日期：" + _vm._s(_vm.Ginkgo.format(_vm.dormOrderInfo.transDt + String(_vm.dormOrderInfo.transTm).padStart(6, '0'), 'time')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('vue-qr', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "logoSrc": _vm.imageUrl,
      "text": _vm.curStudent.studentNo,
      "size": 200
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "3px 0 0 0",
      "width": "50%"
    }
  }, [_vm._v("交费金额：" + _vm._s(_vm.Ginkgo.format(_vm.dormOrderInfo.feeAmount, 'money')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "3px 0 0 0",
      "width": "50%"
    }
  }, [_vm._v("退费金额：" + _vm._s(_vm.Ginkgo.format(_vm.refundMoney, 'money')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px 0"
    }
  }, [_c('table', {
    staticStyle: {
      "color": "rgb(9, 9, 9)",
      "text-align": "center",
      "border-collapse": "collapse",
      "font-size": "3vw",
      "width": "100%"
    },
    attrs: {
      "border": "1"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("收费标准(元)")]), _vm._v(" "), _c('td', [_vm._v("是否领取")])]), _vm._v(" "), _vm._l((_vm.claimApplyList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.supplyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((item.applyStatus === '00') ? '是' : '否'))])])
  })], 2)])])], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e332a9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/XiFan/NewStudent/receive.vue
// module id = 1279
// module chunks = 1